var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll"},[_c('img',{staticClass:"scroll_box",attrs:{"src":require("../assets/zd1.jpg?1")},on:{"click":function($event){return _vm.zd()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }